const TOGGLE_CLASSES = {
  BUTTON: 'icon-invert',
  PANEL_CONTENT_HIDE: 'hidden'
};
const TOGGLE_ATTRIBUTE = 'data-toggle-state';
export const TOGGLES_STATES = {
  OPENED: 'opened',
  CLOSED: 'closed'
};

export function setupToggles(domNode = document) {
  domNode.querySelectorAll('[data-toggle-id]').forEach((toggle) => {
    toggle.setAttribute(TOGGLE_ATTRIBUTE, TOGGLES_STATES.CLOSED);
    const { toggleId } = toggle.dataset;

    toggle.addEventListener('click', () => {
      const panelContent = domNode.getElementById(toggleId);

      if (panelContent) {
        toggle.classList.toggle(TOGGLE_CLASSES.BUTTON);
        toggle.setAttribute(
          TOGGLE_ATTRIBUTE,
          toggle.classList.contains(TOGGLE_CLASSES.BUTTON) ? TOGGLES_STATES.OPENED : TOGGLES_STATES.CLOSED
        );
        panelContent.classList.toggle(TOGGLE_CLASSES.PANEL_CONTENT_HIDE);
      }
    });
  });
}
